import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { NectaUser, UserProfile } from "../models/user";
import { UserStore } from "../store/user.store";

@Injectable({ providedIn: 'root' })
export class UserProfileResolver implements Resolve<NectaUser> {
    store = inject(UserStore);

  resolve(route: ActivatedRouteSnapshot): NectaUser {
    const id = route.paramMap.get('id');
    //if (id && Number(id) && Number(id) > 0) {
    return this.store.getNectaUser(Number(id));
  }
}